/* GSW product card image slider.
   - Auto-slides on its own (only while the card is on screen and the tab is active)
   - Swipe / drag to change image by hand
   - Dots pinned to the bottom of the image. NO arrows anywhere.
   Re-initialises when the collection grid injects cards (filters, sort,
   infinite scroll), so new cards auto-slide too. */
(function () {
  var THRESHOLD = 8;      // px of horizontal movement before it counts as a drag
  var AUTO_MS = 3200;     // time each image is held
  var RESUME_MS = 6000;   // pause length after someone touches the card
  var TICK_MS = 1000;      // how often the shared driver checks

  var items = [];
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var io = window.IntersectionObserver
    ? new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var inst = entries[i].target.gswSliderInstance;
          if (!inst) continue;
          inst.visible = entries[i].isIntersecting;
          if (inst.visible) inst.next = Date.now() + AUTO_MS + inst.stagger;
        }
      }, { threshold: 0.35 })
    : null;

  function init(root) {
    if (root.dataset.gswSliderReady === '1') return;

    var track = root.querySelector('[data-gsw-card-slider-track]');
    var slides = root.querySelectorAll('[data-gsw-card-slide]');
    var dots = root.querySelectorAll('[data-gsw-card-dot]');
    var link = root.querySelector('[data-gsw-card-slider-link]');
    if (!track || slides.length < 2) return;

    root.dataset.gswSliderReady = '1';

    var index = 0;
    var width = 0;
    var startX = 0;
    var startY = 0;
    var delta = 0;
    var dragging = false;
    var moved = false;

    var inst = {
      visible: false,
      hold: false,
      stagger: (items.length % 6) * 420,
      next: Date.now() + AUTO_MS
    };

    function setX(px, animate) {
      if (animate) track.classList.add('is-animating');
      else track.classList.remove('is-animating');
      track.style.transform = 'translate3d(' + px + 'px,0,0)';
    }

    function paintDots() {
      var i;
      for (i = 0; i < dots.length; i++) {
        if (i === index) {
          dots[i].classList.add('is-active');
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].classList.remove('is-active');
          dots[i].setAttribute('aria-current', 'false');
        }
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].setAttribute('aria-hidden', i === index ? 'false' : 'true');
      }
    }

    var pendingIndex = 0;
    function prepareImage(target) {
      var slide = slides[target];
      var template = slide.querySelector('template[data-gsw-card-image]');
      if (template) {
        var fragment = template.content.cloneNode(true);
        var image = fragment.querySelector('img');
        if (image) { image.loading = 'eager'; image.setAttribute('fetchpriority', 'low'); }
        slide.appendChild(fragment);
        template.remove();
      }
      return slide.querySelector('img');
    }
    function go(n, animate) {
      var target = Math.max(0, Math.min(slides.length - 1, n));
      pendingIndex = target;
      var image = prepareImage(target);
      function show() {
        if (pendingIndex !== target || !root.isConnected) return;
        width = root.clientWidth || 1;
        index = target;
        setX(-index * width, animate !== false);
        paintDots();
      }
      if (image && !image.complete) {
        image.addEventListener('load', show, { once: true });
        image.addEventListener('error', function () { if (pendingIndex === target) { pendingIndex = index; setX(-index * (root.clientWidth || 1), true); } }, { once: true });
      } else { show(); }
    }

    inst.advance = function () {
      go((index + 1) % slides.length);
    };

    function hold(ms) {
      inst.next = Date.now() + (ms || RESUME_MS);
    }

    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      inst.hold = true;
      if (e.target.closest && e.target.closest('[data-gsw-card-dot]')) return;
      width = root.clientWidth || 1;
      dragging = true;
      moved = false;
      delta = 0;
      startX = e.clientX;
      startY = e.clientY;
      root.classList.add('is-pointer-down');
    });

    root.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var mx = e.clientX - startX;
      var my = e.clientY - startY;
      if (!moved) {
        if (Math.abs(my) > Math.abs(mx) + 4) {
          dragging = false;
          root.classList.remove('is-pointer-down');
          return;
        }
        if (Math.abs(mx) < THRESHOLD) return;
        moved = true;
      }
      delta = mx;
      if ((index === 0 && delta > 0) || (index === slides.length - 1 && delta < 0)) delta *= 0.35;
      setX(-index * width + delta, false);
    });

    function release() {
      inst.hold = false;
      hold(RESUME_MS);
      if (!dragging) return;
      dragging = false;
      root.classList.remove('is-pointer-down');
      if (moved && Math.abs(delta) > width * 0.18) go(index + (delta < 0 ? 1 : -1));
      else go(index);
    }

    root.addEventListener('pointerup', release);
    root.addEventListener('pointercancel', release);
    root.addEventListener('pointerleave', release);

    root.addEventListener('mouseenter', function () { inst.hold = true; });
    root.addEventListener('mouseleave', function () { inst.hold = false; hold(RESUME_MS); });

    if (link) {
      link.addEventListener('click', function (e) {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      });
    }

    for (var d = 0; d < dots.length; d++) {
      (function (i) {
        dots[i].addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          go(i);
          hold(RESUME_MS);
        });
      })(d);
    }

    window.addEventListener('resize', function () { go(index, false); }, { passive: true });

    paintDots();

    root.gswSliderInstance = inst;
    items.push(inst);

    if (io) io.observe(root);
    else inst.visible = true;
  }

  function drive() {
    if (reduceMotion || document.hidden) return;
    var now = Date.now();
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.visible || it.hold) continue;
      if (now >= it.next) {
        it.advance();
        it.next = now + AUTO_MS;
      }
    }
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    var now = Date.now();
    for (var i = 0; i < items.length; i++) items[i].next = now + AUTO_MS;
  });

  function boot() {
    var all = document.querySelectorAll('[data-gsw-card-slider]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if (window.MutationObserver) {
    var observerRoot = document.querySelector('main') || document.body;
    new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (!node || node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-gsw-card-slider]')) init(node);
          if (!node.querySelectorAll) continue;
          var sliders = node.querySelectorAll('[data-gsw-card-slider]');
          for (var s = 0; s < sliders.length; s++) init(sliders[s]);
        }
      }
    }).observe(observerRoot, { childList: true, subtree: true });
  }

  setInterval(drive, TICK_MS);
})();
